import { Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import EditModal from './shared_edit_modal';
import { BrokerError, BrokerPanel, deleteRecord, modifyRecordArray } from './shared';
import Button from 'shared/button';

export default function Departments(props: DepartmentsProps) {
  const [departments, setDepartments] = useState<Department[]>(props.departments);
  const [modalObject, setModalObject] = useState<{ isOpen: boolean; id: string | number }>({ isOpen: false, id: '' });
  const [error, setError] = useState<string>('');

  const openModal = (id: string | number) => setModalObject({ isOpen: true, id });
  const closeModal = () => setModalObject({ isOpen: false, id: '' });
  const departmentToEdit = modalObject.id === ''
    ? null
    : departments.find(department => department.id === modalObject.id);

  const handleFormSubmit = (newDepartment: Department) => {
    modifyRecordArray(newDepartment, setDepartments, departments, 'name', modalObject, closeModal);
  };

  const deleteDepartment = ({ name, id }: { name: string; id: number }) => {
    deleteRecord(id, name, '/company_departments', 'Department', setDepartments, setError);
  };

  const editFields = [{ name: 'name', isRequired: true, value: departmentToEdit?.name }];

  const addNewDepartment = () => openModal('');

  return (
    <React.Fragment>
      <Modal
        dialogClassName="modal-sm"
        show={modalObject.isOpen}
        onHide={closeModal}
      >
        <EditModal
          databaseName="company_department"
          editFields={editFields}
          id={modalObject.id}
          key={`${modalObject.isOpen}-${modalObject.id}`}
          objectName="Department"
          onCloseModal={closeModal}
          onSuccessfulFormSubmit={handleFormSubmit}
        />
      </Modal>
      <div className="d-flex justify-content-between mb-3 align-items-center top-buffer-xl">
        <h2 className="m-0">Departments</h2>
        <Button.Primary onClick={addNewDepartment}>Add Department</Button.Primary>
      </div>

      <BrokerError error={error}/>
      <BrokerPanel
        cantModifyMessage="Corporate Department"
        deleteRecord={deleteDepartment}
        firstColumnIdentifier="name"
        openModal={openModal}
        recordName="Department"
        records={departments}
        secondColumnIdentifier=""
        onClick={addNewDepartment}
      />

    </React.Fragment>
  );
}

export interface Department {
  canModify: boolean;
  id: number;
  name: string;
}

interface DepartmentsProps {
  departments: Department[];
}
